import { ConversionTypeHeader } from '../ConversionTypeHeader/ConversionTypeHeader';
import styles from './eventHeader.module.scss';

export const EventHeader = ({ event }) => (
    <div className={styles['header']}>
        <ConversionTypeHeader event={event} />
    </div>
);
